<script>
    import { questions, lang } from "../scripts/stores";
    import { pageTitles_fi, pageTitles_en, groups_fi, groups_en, tresh1, tresh2, tresh3 } from "../scripts/questions";
    import { location } from "svelte-spa-router";
    import { onMount } from "svelte";

    export let params = {};

    let pageTitles = $lang === "fi" ? pageTitles_fi : pageTitles_en;
    let groups = $lang === "fi" ? groups_fi : groups_en;

    $: if($lang) {
        pageTitles = $lang === "fi" ? pageTitles_fi : pageTitles_en;
        groups = $lang === "fi" ? groups_fi : groups_en;
    }

    let { group } = params;
    let questionsPerGroup = $questions.filter(question => question.group === Number(group) + 1);
    questionsPerGroup.sort((a, b) => b.value - a.value);

    $: if($location) { 
        group = params.group;
        questionsPerGroup = $questions.filter(question => question.group === Number(group) + 1);
        questionsPerGroup.sort((a, b) => b.value - a.value);
    }

    function getColor(value) {
        let color = "red";

        if(value !== 0) value = value / 100;
        value = 1 - value;

        if(value <= tresh1) color = "rgb(255, 51, 51)";
        else if(value > tresh1 && value < tresh2) color = "rgb(255, 170, 51)";
        else if(value >= tresh2 && value < tresh3) color = "rgb(255, 235, 0)";
        else if(value >= tresh3) color = "rgb(0, 204, 102)";

        return color;
    }

    onMount(() => {
        window.scrollTo(0, 0);
    })
</script>

<style>
    .progress-container {
        width: 640px;
        max-width: 95%;
        margin: 2rem auto;
        --progress-color: rgb(0, 204, 102);
    }
    .progress-item {
        margin-bottom: 1.5rem;
        padding: 1rem 0;
        border-bottom: 1px solid lightgray;
    }
    @media screen and (min-width: 900px) {
        .progress-item:hover {
            background: rgba(0, 0, 0, .015);
        }
    }
    .width {
        width: 480px;
        max-width: 90%;
        margin-top: 1rem;
    }
    progress::-webkit-progress-value {
        background: var(--progress-color);
    }
    progress::-moz-progress-bar {
        background: var(--progress-color);
    }
</style>

<div class="progress-container">
    <h2>
        { $lang === "fi" ? "Kaikki vastaukset kategoriasta" : "All answers from category" } { groups[group].toLowerCase() } </h2>
    
    {#each questionsPerGroup as question, i}
        {#if !question.skip}
            <div class="progress-item">
                <p>
                    { i + 1 }.
                    {#if question.isFull}
                        { question.title }
                    {:else}
                        { pageTitles[question.page].replace("...", "") }
                        { question.title.toLowerCase() }
                    {/if}
                    ({ question.value }/100)
                </p>

                <progress value={ question.value || 3} min="3" max="100" 
                          class="progress width" style="--progress-color: {getColor(question.value)}">
                </progress>

                {#if question.details}
                    <div style="margin-top: 1rem;">
                        <b>{ $lang === "fi" ? "Muistiinpanot" : "Notes" }</b> <br />
                        <p> { question.details } </p>
                    </div>
                {/if}
            </div>
        {/if}
    {/each}

    <a href="/#/results-page" class="btn btn-primary">
        { $lang === "fi" ? "Palaa yhteenvetoon" : "Back to overall points" }
    </a>
</div>